export default {
  // Settings
  "settings": "Paramètres",
  "profile": "Profil",
  "security": "Sécurité",
  "theme": "Thème",
  "feedback": "Retour d'information",
  "data": "Données",
  "appearance_settings": "Paramètres d'apparence",
  "select_theme": "Sélectionnez votre thème préféré",
  "light": "Clair",
  "dark": "Sombre",
  "system": "Système",
  "language_changed": "Langue changée en",
  "failed_update_language": "Échec de la mise à jour de la langue",
  "profile_settings": "Paramètres de profil",
  "username_cannot_change": "Vous ne pouvez pas changer votre nom d'utilisateur pour",
  "more_days": "jours de plus",
  "email_cannot_change": "L'email ne peut pas être modifié",
  "profile_links": "Liens de profil",
  "link_one": "Lien 1",
  "link_two": "Lien 2",
  "password_change": "Changer le mot de passe",
  "current_password": "Mot de passe actuel",
  "new_password": "Nouveau mot de passe",
  "confirm_password": "Confirmer le mot de passe",
  "update_password": "Mettre à jour le mot de passe",
  "password_must_be": "Le mot de passe doit comporter entre 8 et 25 caractères",
  "security_questions": "Questions de sécurité",
  "security_question": "Question de sécurité",
  "update_security_questions": "Mettre à jour les questions de sécurité",
  "setup_security_questions": "Configurer les questions de sécurité",
  "select_question": "Sélectionner une question",
  "your_answer": "Votre réponse",
  "enter_your_answer": "Entrez votre réponse",
  "submit_feedback": "Soumettre un retour",
  "feedback_type": "Type de retour",
  "general_feedback": "Retour général",
  "bug_report": "Signalement de bug",
  "feature_request": "Demande de fonctionnalité",
  "airport_request": "Demande de nouvel aéroport",
  "airport_iata": "Code IATA de l'aéroport",
  "airport_name": "Nom de l'aéroport",
  "airport_location": "Localisation de l'aéroport",
  "your_feedback": "Votre retour",
  "data_management": "Gestion des données",
  "delete_all_films": "Supprimer tous les films",
  "delete_films_warning": "Cela supprimera définitivement tous les films de votre inventaire. Cette action ne peut pas être annulée.",
  "delete_all_reviews": "Supprimer tous les avis",
  "delete_reviews_warning": "Cela supprimera définitivement tous vos avis. Cette action ne peut pas être annulée.",
  "delete_account": "Supprimer le compte",
  "delete_account_warning": "Attention : Cette action ne peut pas être annulée. Cela supprimera définitivement votre compte et toutes vos données de nos serveurs.",
  "account_deleted_success": "Votre compte a été supprimé avec succès",
  "account_deletion_failed": "Échec de la suppression du compte",
  "reviews_deleted_success": "Tous vos avis ont été supprimés avec succès",
  "reviews_deletion_failed": "Échec de la suppression des avis",
  "films_deleted_success": "Tous vos films ont été supprimés avec succès",
  "films_deletion_failed": "Échec de la suppression des films",
  "confirm_delete_films": "Êtes-vous sûr de vouloir supprimer tous vos films ? Cette action ne peut pas être annulée.",
  "confirm_delete_reviews": "Êtes-vous sûr de vouloir supprimer tous vos avis ? Cette action ne peut pas être annulée.",
  "confirm_delete_account": "Êtes-vous sûr de vouloir supprimer votre compte ? Cette action ne peut pas être annulée.",
  "create_username": "Créer un nom d'utilisateur",
  "username_required_description": "Veuillez créer un nom d'utilisateur pour votre compte. Les noms d'utilisateur doivent être uniques et peuvent contenir des lettres, des chiffres et des tirets bas.",
  "username": "Nom d'utilisateur",
  "username_placeholder": "Entrez un nom d'utilisateur",
  "username_requirements": "Le nom d'utilisateur doit comporter entre 4 et 25 caractères et ne peut contenir que des lettres, des chiffres et des tirets bas.",
  "save_username": "Enregistrer le nom d'utilisateur",
  "username_taken": "Ce nom d'utilisateur est déjà pris",
  "username_set_success": "Nom d'utilisateur défini avec succès",
  "username_set_error": "Échec de la définition du nom d'utilisateur"
};
